import { combineReducers } from 'redux';
import { nuevaPresentacionReducer } from './nuevaPresentacion.reducer';
import { adjuntarArchivoReducer } from './adjuntarArchivo.reducer';
import { internacionesReducer } from './internaciones.reducer';
import { grillaPrincipalReducer } from './grillaPrincipal';
import { authReducer } from './auth.reducer';
import { ventanaDialogoReducer } from './ventanaDialogo.reducer';
import { snackMensajeReducer } from './snackMensaje.reducer';

const rootReducer = combineReducers({
    nuevaPresentacionReducer,
    adjuntarArchivoReducer,
    internacionesReducer,
    grillaPrincipalReducer,
    authReducer,
    ventanaDialogoReducer,
    snackMensajeReducer,
});

export default rootReducer;
